import React from 'react';
import { Check } from '@phosphor-icons/react';

const STEPS = [
  { id: 1, label: 'Jornada' },
  { id: 2, label: 'Equipos' },
  { id: 3, label: 'Tareas' }
];

const TaskDistributionStepNavigation = ({
  activeStep,
  dateLabel,
  selectedTeamCount,
  selectedTaskCount,
  completedSteps,
  maxAccessibleStep,
  onStepChange
}) => (
  <div className="grid grid-cols-3 gap-2 sm:gap-3">
    {STEPS.map((step) => {
      const isActive = step.id === activeStep;
      const isCompleted = step.id < activeStep && completedSteps[step.id];
      const isDisabled = step.id > maxAccessibleStep;
      const selectedCount = step.id === 2 ? selectedTeamCount : selectedTaskCount;
      const summary = step.id === 1
        ? dateLabel
        : selectedCount > 0
          ? `${selectedCount} seleccionados`
          : 'Sin seleccionar';

      return (
        <button
          key={step.id}
          type="button"
          disabled={isDisabled}
          onClick={() => onStepChange(step.id)}
          aria-current={isActive ? 'step' : undefined}
          className={`flex min-w-0 items-center gap-2 rounded-xl border px-2 py-2 text-left transition sm:px-3 ${
            isActive
              ? 'border-amber/70 bg-amber-hover/10'
              : isDisabled
                ? 'cursor-not-allowed border-transparent opacity-45'
                : 'border-transparent hover:border-line hover:bg-surface/70'
          }`}
        >
          <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border text-xs font-bold ${
            isActive
              ? 'border-amber bg-amber-hover text-on-amber'
              : isCompleted
                ? 'border-emerald-500/60 bg-emerald-500/10 text-emerald-400'
                : 'border-line bg-surface-2 text-content-muted'
          }`}>
            {isCompleted ? <Check size={15} weight="bold" /> : step.id}
          </span>
          <span className="min-w-0">
            <span className="block truncate text-xs font-semibold text-content sm:text-sm">{step.label}</span>
            <span className="block truncate text-[9px] text-content-muted sm:text-[10px]">{summary}</span>
          </span>
        </button>
      );
    })}
  </div>
);

export default TaskDistributionStepNavigation;
